import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ReportsIconSvg = (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5005 23.9031C11.559 17.0061 17.6444 11.0948 24.0002 11.5218V23.9031H36.5C36.0763 31.5881 30.7495 36.6168 23.7884 36.4979C16.9442 36.381 11.442 30.8001 11.5005 23.9031Z"
            stroke="currentColor"/>
        <path d="M27.5 19.5V8.5C33.3868 8.49999 39.5 13.1852 39.5 19.5H27.5Z" stroke="currentColor"/>
    </svg>


)
const ReportsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ReportsIconSvg}
    </SvgIcon>
);
export default ReportsIcon